<template>
    <div class="shrink-0 px-3 pb-3">
        <div class="journeys-workflow-footer flex flex-wrap items-center justify-between gap-3 rounded-xl bg-[#3A3631] px-5 py-4 text-white">
            <div class="flex min-w-0 flex-col gap-0.5">
                <p class="text-base leading-6 font-medium font-sans" aria-live="polite">{{ title }}</p>
                <p class="text-sm leading-5 text-[#DAD4CB] font-sans">{{ description }}</p>
            </div>
            <button
                :data-testid="testId"
                type="button"
                class="journeys-workflow-footer__action"
                :disabled="disabled || isSubmitting"
                :aria-busy="isSubmitting"
                @click="emit('continue')">
                {{ isSubmitting ? "Saving…" : actionLabel }}
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
defineProps<{
    title: string;
    description: string;
    actionLabel: string;
    testId: string;
    disabled: boolean;
    isSubmitting: boolean;
}>();

const emit = defineEmits<{
    continue: [];
}>();
</script>

<style scoped>
@reference "../../../../css/tailwind.css";

.journeys-workflow-footer__action {
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    min-height: 40px;
    padding: 8px 16px;
    border-radius: 8px;
    background: #fff;
    color: #2a2723;
    font-family: var(--font-app, Inter, sans-serif);
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    transition: background 150ms ease;
}

.journeys-workflow-footer__action:hover {
    background: #f7f5f2;
}

.journeys-workflow-footer__action:disabled {
    cursor: not-allowed;
    opacity: 0.6;
}
</style>
